export { relatedLinksComponentParams } from './builder';
export { collectRelatedLinksParams } from './collector';
export { default as RelatedLinks } from './RelatedLinks';
